import data from '../data';

/**
 * Creator function that generates all pending model reducers
 *
 * @param {Object} options The options for the creator
 * @param {Object} options.customConfigs Any custom handlers for the reducers
 * @return {Object} The object holding all of the pending reducers
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * import { combineReducers } from 'redux';
 *
 * const pending = combineReducers({ ...makePendingReducers() });
 * const rootReducer = combineReducers({
 *   pending,
 * });
 */
const makePendingReducers = (options = {}) => {
  const { customConfigs = {} } = options;

  return {
    data: data({ customConfig: customConfigs.data }),
  };
};

/** @component */
export default makePendingReducers;
